import styled from 'styled-components';
import { COLORS } from '@themes';

const WIDTH = 400;
const HEIGHT = 220;
const PADDING = 20;

export const Style = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  .block {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${COLORS.WHITE_1};
    opacity: 0.1;
  }
  .modal {
    width: ${WIDTH}px;
    height: ${HEIGHT}px;
    word-wrap: break-word;
    background-color: ${COLORS.BLACK_1};
    border-radius: 6px;
    position: absolute;
    top: calc(50% - ${HEIGHT / 2 + PADDING / 2}px);
    left: calc(50% - ${WIDTH / 2 + PADDING / 2}px);
    z-index: 2;
    text-align: center;
    padding: ${PADDING}px;
    font-weight: 600;
    .img {
      margin-top: 20px;
      width: 80px;
    }

    .content {
      font-size: 18px;
    }

    .btn-close {
      cursor: pointer;
      color: ${COLORS.BLUE_1};
      border: 1px solid ${COLORS.BLUE_1};
      box-sizing: border-box;
      padding: 4px 10px;
      border-radius: 4px;
      font-size: 12px;
      margin: auto;
      margin-top: 30px;
      width: fit-content;
    }
  }
`;
